import { render, staticRenderFns } from "./superiorAssessmentForm.vue?vue&type=template&id=3747d1f0&"
import script from "./superiorAssessmentForm.vue?vue&type=script&lang=js&"
export * from "./superiorAssessmentForm.vue?vue&type=script&lang=js&"
import style0 from "./superiorAssessmentForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports